<div class="flex flex-col">
  <label class="block text-xs font-semibold text-[#25282D] mb-1">
    {{ label }}
    <span
      *ngIf="showAsterisk"
      class="text-orange-500 text-xs font-semibold"
      aria-hidden="true"
      >*</span
    >
  </label>

  <div
    #chipContainer
    class="w-full flex flex-wrap items-center gap-2 rounded-[5px] border border-[#DBE0E6] bg-[#F8F8FE] px-2 py-[6px] focus-within:!border-[#C7B1FF] focus-within:ring-[#C7B1FF] max-h-24 overflow-y-auto"
  >
    <span
      *ngFor="let chip of values; let i = index"
      class="flex items-center gap-1 rounded-full bg-[#F1E8FF] text-[#6729FF] border border-[#6729FF]/40 pl-3 pr-1 py-1 text-[11px] font-medium"
    >
      {{ chip }}
      <button
        type="button"
        class="text-[#6729FF] hover:text-[#4A1CCB] focus:outline-none leading-none"
        (click)="removeChip(i)"
        aria-label="Remove value"
        [disabled]="disabled"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-4"
        >
          <path
            fill-rule="evenodd"
            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </span>

    <input
      class="flex-1 min-w-[120px] bg-transparent border-0 text-[#25282D] text-[13px] placeholder:text-[12px] placeholder-[#96A0B5] focus:outline-none focus:ring-0"
      [placeholder]="placeholder"
      name="chipInput"
      [(ngModel)]="valueInput"
      (keydown)="onChipKeydown($event)"
      [required]="required && values.length === 0"
      [disabled]="disabled"
    />
  </div>
</div>
